import React from 'react';
import ReactDOM from 'react-dom/client';
import NPSDashboard from './NPSDashboard';
import './index.css';

// Registrazione Service Worker per PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => console.log('SW registrato:', reg.scope))
      .catch((err) => console.error('SW errore:', err));
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <NPSDashboard />
  </React.StrictMode>
);
